const sortByName = (a, b) => {
  let itemA = a.name.toLowerCase()
  let itemB = b.name.toLowerCase()

  if (itemA < itemB) return -1
  if (itemA > itemB) return 1
  return 0
}

const sortByRoles = (a, b) => {
  return b.roles.length - a.roles.length
}

const sortByEntities = (a, b) => {
  return b.entities.length - a.entities.length
}

const sortById = (a, b) => {
  return a.id - b.id
}

export {
  sortById,
  sortByName,
  sortByRoles,
  sortByEntities,
}
